//import { debugLog } from '../../utils';
import { DemoData, IType } from '../types';
import { Fetch } from './Fetch';

export const Account = {
	getList: async (search?: string | undefined): Promise<IType[]> => {
		return DemoData.enabled ?
			await new Promise<IType[]>(resolve => resolve(DemoData.contacts)) :
			await Fetch.getTypes(`/management/accounts?${search ? 'search=' + search : 'pageSize=500'}`)
	},

	getContacts: async (accountId: string, search?: string | undefined): Promise<IType[]> => {
		//debugLog(`Loading contacts for account ID=${accountId} search=${search}`);
		if( !accountId )
			return [];
		return DemoData.enabled ?
			await new Promise<IType[]>(resolve => resolve(DemoData.contacts)) :
			await Fetch.getTypes(`/management/account/${accountId}/contacts?${search ? 'search=' + search : 'pageSize=500'}`)
	},

	getPartners: (search?: string | undefined): Promise<IType[]> => 
		DemoData.enabled ?
			new Promise<IType[]>(resolve => resolve(DemoData.partners)) :
			Fetch.getTypes(`/management/accounts?type=partner&${search ? 'search=' + search : 'search=resco&pageSize=500'}`),

	getCustomers: (search?: string | undefined): Promise<IType[]> =>
		DemoData.enabled ?
			new Promise<IType[]>(resolve => resolve(DemoData.customers)) :
			Fetch.getTypes(`/management/accounts?type=customer&${search ? 'search=' + search : 'pageSize=500'}`)
}
